import axios from "axios";
import common from "@/common/functions.js";
import UserService from "@/common/user.service.js";
import TokenService from "@/common/token.service.js";
const backendUrl = process.env.VUE_APP_BACKEND_URL;

// Setting up refresh tokens on bad request
function refreshToken() {
  let refresh = TokenService.getRefreshToken();

  return axios
    .post(process.env.VUE_APP_BACKEND_URL + "/api/token/refresh/", {
      refresh: refresh
    })
    .then(response => {
      TokenService.setAccessToken(response.data.access);
    });
}

axios.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    const {
      config,
      response: { status, data }
    } = err;
    const isTokenValidError = status === 401 && data.code === "token_not_valid";
    const TokenErrorDetail = "Token is invalid or expired";

    // if its not a token valid error, continue
    if (!isTokenValidError) {
      return Promise.reject(err);
    }

    // if its a token error, try to refresh the token
    if (data.detail === TokenErrorDetail) {
      return refreshToken()
        .then(_ => {
          const token = TokenService.getAccessToken();
          config.headers["Authorization"] = `Bearer ${token}`;
          if (config.data.token !== null){
            config.data.token = token;
          }
          return new Promise((resolve, reject) => {
            axios
              .request(config)
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          });
        })
        .catch(error => {
          UserService.logOut();
          router.push({ name: "Login" });
          return Promise.reject(error);
        });
    }
  }
);

export class ApiService {
  jsonHeader = { "Content-Type": "application/json" };

  static authHeader() {
    let access = TokenService.getAccessToken();
    if (access) {
      return { Authorization: "Bearer " + access };
    }
    return {};
  }

  static putHeadersInOtions(requestOptions, headers, auth) {
    if (auth) {
      requestOptions.headers = this.authHeader();
    }
    if (!common.isObjEmpty(headers)) {
      for (let key in headers) {
        if (headers.hasOwnProperty(key)) {
          requestOptions.headers[key] = headers[key];
        }
      }
    }
    return requestOptions;
  }

  static get(url, headers = {}, auth = true) {
    let requestOptions = {
      method: "GET",
      url: url,
      headers: {}
    };
    requestOptions = this.putHeadersInOtions(requestOptions, headers, auth);
    return axios(requestOptions);
  }

  static post(url, data, headers = {}, auth = true) {
    let requestOptions = {
      method: "POST",
      url: url,
      headers: {},
      data: data
    };
    requestOptions = this.putHeadersInOtions(requestOptions, headers, auth);
    return axios(requestOptions);
  }

  static delete(url, headers = {}, auth = true) {
    let requestOptions = {
      method: "DELETE",
      url: url,
      headers: {}
    };
    requestOptions = this.putHeadersInOtions(requestOptions, headers, auth);
    return axios(requestOptions);
  }

  static put(url, data, headers = {}, auth = true) {
    let requestOptions = {
      method: "PUT",
      url: url,
      headers: {},
      data: data
    };
    requestOptions = this.putHeadersInOtions(requestOptions, headers, auth);
    return axios(requestOptions);
  }

  static patch(url, data, headers = {}, auth = true) {
    let requestOptions = {
      method: "PATCH",
      url: url,
      headers: {},
      data: data
    };
    requestOptions = this.putHeadersInOtions(requestOptions, headers, auth);
    return axios(requestOptions);
  }
}
